import * as React from "react";
import { HotelHeartButtonProps } from "./typings";
import { EntityType, HeartButton } from "components/shared/HeartButton/HeartButton";

function buildPayload(id: string, isoCheckIn?: string, isoCheckOut?: string) {
  return {
    chkIn: (isoCheckIn && isoCheckIn.replace(/-/g, "")) || "",
    chkOut: (isoCheckOut && isoCheckOut.replace(/-/g, "")) || "",
    favoriteId: id,
    roomConfiguration: "2"
  };
}

export function HotelHeartButton(props: HotelHeartButtonProps) {
  const { moduleName, l10n, hotel } = props;

  if (!module || !l10n || !hotel) {
    return null;
  }

  return (
    <HeartButton
      moduleName={moduleName}
      heartableEntity={{
        id: hotel.hotelId,
        name: hotel.hotelName,
        entityType: EntityType.HOTEL,
        payload: buildPayload(hotel.hotelId, hotel.isoCheckIn, hotel.isoCheckOut)
      }}
    />
  );
}
